module.exports = __webpack_public_path__ + "img/vacant-shift.8e031223.svg";